import { useCanvas } from './canvas-context';
import { quietLineOf, type QuietLineTool } from './quiet-line';

/**
 * FRONT-2669 — the single muted line that stands in for the generic tool step
 * of the five document/sketch/deck tools. Never renders the tool's input (the
 * document body). Inside a Canvas context with that item in the list the line is
 * a button that opens the panel on it; everywhere else (flag off, other shells)
 * it is plain text.
 */
export function QuietToolLine({ tool }: { tool: QuietLineTool }) {
  const canvas = useCanvas();
  const line = quietLineOf(tool, (key) => canvas?.items.find((i) => i.key === key)?.title ?? null);
  if (!line) return null;
  const itemKey = line.itemKey;
  if (canvas && itemKey && canvas.items.some((i) => i.key === itemKey)) {
    return (
      <button
        type="button"
        data-testid="canvas-quiet-line"
        onClick={() => canvas.openItem(itemKey)}
        className="self-start text-left text-xs text-muted-foreground hover:text-foreground focus-visible:text-foreground underline-offset-2 hover:underline cursor-pointer"
      >
        {line.text}
      </button>
    );
  }
  return (
    <p data-testid="canvas-quiet-line" className="text-xs text-muted-foreground">
      {line.text}
    </p>
  );
}
